import * as React from 'react';
import styles from './TextInput.module.css';

interface TextInputProps {
    name: string;
    type?: 'text' | 'email' | 'url';
    placeholder?: string;
    maxLength?: number;
    minLength?: number;
    required?: boolean;
    className?: string;
}

export const TextInput: React.FC<TextInputProps> = ({
                                                        name,
                                                        type = 'text',
                                                        placeholder,
                                                        maxLength,
                                                        minLength,
                                                        required = false,
                                                        className,
                                                    }) => {
    return (
        <input
            name={name}
            type={type}
            className={`${styles.input} ${className}`}
            placeholder={placeholder}
            maxLength={maxLength}
            minLength={minLength}
            required={required}
        />
    );
};
